import * as React from "react";
const SvgChevronRightDouble = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4 14.75 5-5-5-5m7 10 5-5-5-5"
    />
  </svg>
);
export default SvgChevronRightDouble;
